import type { OrgCreate, OrgPatch, OrgSummary } from '@escala/contracts';
import type { Organization, OrgStatus } from '@escala/domain/types';

import type { Api } from '@/services/api/escala';
import { ApiError, NetworkError } from '@/services/http';

import { problemMessage } from './remote';

/**
 * Organizações (página Organizações, do Administrador da plataforma, e o card de
 * Configurações): cada operação é uma rota de `/orgs` (nos testes, `test/memory`).
 */
export interface OrgsClient {
  list: () => Promise<OrgSummary[]>;
  create: (input: OrgCreate) => Promise<OrgSummary>;
  update: (orgId: string, patch: OrgPatch) => Promise<Organization>;
  setStatus: (orgId: string, status: OrgStatus) => Promise<OrgSummary>;
  /** Reenvia o convite do administrador (a plataforma), corrigindo o e-mail se vier um. */
  inviteAdmin: (orgId: string, email?: string) => Promise<OrgSummary>;
  slugCheck: (slug: string, orgId?: string) => Promise<{ available: boolean; error: string | null }>;
}

export function apiOrgs(api: Api): OrgsClient {
  return {
    list: api.orgs,
    create: api.createOrg,
    update: api.updateOrg,
    setStatus: api.setOrgStatus,
    inviteAdmin: api.inviteOrgAdmin,
    slugCheck: api.slugCheck,
  };
}

/** Chave da lista de organizações no React Query (página Organizações e menu lateral). */
export const ORGS_KEY = ['orgs'] as const;

/** O motivo da recusa para a tela: o da API ou o de rede. */
export function orgErrorMessage(error: unknown): string {
  if (error instanceof NetworkError) return 'Não foi possível falar com o servidor. Verifique sua conexão.';
  if (error instanceof ApiError) return problemMessage(error);

  return 'Não foi possível concluir. Tente de novo.';
}
